module.exports = __webpack_public_path__ + "img/ico_curtain_4.36438adf.png";